(function () {
  // your code...
  (function () {
  function fixGalleryHeights() {
    if (window.innerWidth > 740) return;

    var items = document.querySelectorAll(".eg_grid_gallery_app_section .mainul > li");

    items.forEach(function (item) {
      var poster =
        item.querySelector(".esg-media-poster") ||
        item.querySelector(".esg-entry-media-poster");

      if (!poster) return;

      var bg = window.getComputedStyle(poster).backgroundImage;
      if (!bg || bg === "none") return;

      var match = bg.match(/url\((['"]?)(.*?)\1\)/);
      if (!match || !match[2]) return;

      var imgUrl = match[2];
      var width = item.clientWidth || item.offsetWidth;
      if (!width) return;

      var img = new Image();
      img.onload = function () {
        if (!img.naturalWidth || !img.naturalHeight) return;

        var exactHeight = Math.round((img.naturalHeight / img.naturalWidth) * width);

        item.style.height = exactHeight + "px";

        [
          ".esg-entry-cover",
          ".esg-entry-media",
          ".esg-media-cover-wrapper",
          ".esg-media-poster",
          ".esg-entry-media-poster"
        ].forEach(function (sel) {
          var el = item.querySelector(sel);
          if (el) el.style.height = exactHeight + "px";
        });
      };

      img.src = imgUrl;
    });
  }

  fixGalleryHeights();
  setTimeout(fixGalleryHeights, 400);
  setTimeout(fixGalleryHeights, 1000);
  window.addEventListener("resize", fixGalleryHeights);
})();
})();